import { Box, Typography, Paper } from "@mui/material";

const WelcomePage = () => {
  return (
    <Box
      sx={{
        height: "80vh",
        background: "linear-gradient(135deg, #f5f7fa, #c3cfe2)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          px: 6,
          py: 4,
          borderRadius: 4,
          backgroundColor: "white",
          textAlign: "center",
        }}
      >
        <Typography variant="h3" fontWeight={600} gutterBottom>
          Welcome to <span style={{ color: "#1976d2" }}>TMS</span>
        </Typography>
        <Typography variant="h6" color="text.secondary">
          Translation Management System
        </Typography>
      </Paper>
    </Box>
  );
};

export default WelcomePage;
